import React from "react";
import PartnersDisplay from "../components/PartnersDisplay/PartnersDisplay";
import styles from "./page.default.module.css";
import { useTranslation } from "react-i18next";

const Sponsors: React.FC = () => {
  const { t } = useTranslation();
  return (
    <section className={styles.pageSection}>
      <div className={styles.container}>
        <div className={styles.heading}>
          <h1 className={styles.title}>{t("partnersDisplay.title")}</h1>
          <p className={styles.description}>
            {t("partnersDisplay.description")}
          </p>
        </div>
        <PartnersDisplay />
      </div>
    </section>
  );
};

export default Sponsors;
